import {
    AfterContentInit,
    AfterViewInit,
    Directive,
    effect,
    ElementRef,
    inject,
    input,
    InputSignal,
    OnDestroy,
    OnInit
} from "@angular/core";
import {ResponsiveService} from "../responsive/responsive.service";

@Directive({
    selector: "[woa-element-width]"
})
export class ElementWidthDirective implements OnInit, AfterViewInit, AfterContentInit, OnDestroy {
    private element: ElementRef = inject(ElementRef);
    private responsiveService: ResponsiveService = inject(ResponsiveService);

    public readonly widthProperty: InputSignal<string> = input<string>("--woa-element-width");

    private elementWidth: number = undefined;
    private destroyed: boolean = false;

    constructor() {
        effect(() => this.setElementWidthProperty());
    }

    ngOnInit(): void {
        this.setElementWidthProperty();
    }

    ngAfterViewInit(): void {
        this.setElementWidthProperty();
    }

    ngAfterContentInit(): void {
        this.setElementWidthProperty();
    }

    ngOnDestroy(): void {
        this.destroyed = true;
    }

    private setElementWidthProperty(): void {
        if (!this.responsiveService.windowWidth()) {
            return;
        }
        setTimeout(() => {
            if (this.element && !this.destroyed) {
                const elementWidth: number = this.element.nativeElement.clientWidth;
                if (elementWidth !== this.elementWidth) {
                    this.elementWidth = elementWidth;
                    this.element.nativeElement.style.setProperty(this.widthProperty(), elementWidth);
                }
            }
        });
    }
}
